/**
 * E215.F2 (GUS-315, reteste de 01/11): a conclusão registrada aparecia "0 de 1" numa aba da mesa e
 * "1 de 1" depois de recarregar. A mesa tem duas leituras das peças: a dela (`useMesaEletronica`,
 * relida pela conclusão) e a da área do material (a pré-análise, com o painel do caso e o contador),
 * que só se relia quando a mesa gravava pelo editor. Este gancho conta as mudanças no estado de
 * conclusão das peças da mesa, para a área do material se reler junto; a primeira leitura não conta.
 */
import { useEffect, useMemo, useRef, useState } from 'react';

import { pecaConcluida, type ExameEletronicoCcbData } from '@/lib/exame_eletronico_ccb';

export function useMudancaDasConclusoes(
  pecas: readonly ExameEletronicoCcbData[] | null | undefined,
): number {
  const conclusoes = useMemo(
    () =>
      pecas == null
        ? null
        : pecas.map((p) => `${p.source_document_id}:${pecaConcluida(p)}`).join('|'),
    [pecas],
  );
  const antes = useRef<string | null>(null);
  const [mudancas, setMudancas] = useState(0);
  useEffect(() => {
    if (conclusoes === null) return;
    if (antes.current !== null && antes.current !== conclusoes) setMudancas((n) => n + 1);
    antes.current = conclusoes;
  }, [conclusoes]);
  return mudancas;
}
